<template>
    <div class="page">
        <div class="main-title">我的售后</div>

        <div class="page-ctx">
            <div class="tab-box">
                <div class="tab-list">
                    <div
                        v-for="(item, index) in list_status_refund"
                        :key="index"
                        class="tab-item"
                        :class="refund_status == item.status ? 'active' : ''"
                        @click="refund_status = item.status"
                    >
                        {{ item.title }} <span style="color: #ff4d00" v-if="index > 0">{{ tabNum(item.status) }}</span>
                    </div>
                </div>
                <div class="search-box">
                    <input v-model="keyword" type="text" placeholder="输入商品名称、订单号" />
                    <div class="queryBtn" @click="click_order_search">
                        <img src="@/assets/img/mine/query.png" class="img" alt="" />
                    </div>
                </div>
            </div>

            <div class="center ctx-box">
                <template v-if="!isRefundApply">
                    <!-- 可申请售后列表 -->
                    <refundList :list="list_order" />
                    <el-empty v-if="!list_order.length" description="暂无数据..."></el-empty>
                </template>
                <template v-else>
                    <!-- 售后申请列表 -->
                    <refundApplyList :list="list_refund" />
                    <el-empty v-if="!list_refund.length" description="暂无数据..."></el-empty>
                </template>

                <div
                    v-if="!((!isRefundApply && !list_order.length) || (isRefundApply && !list_refund.length))"
                    class="pagination-box"
                    style="margin-top: 40px"
                >
                    <el-pagination
                        @current-change="changePage"
                        :current-page.sync="pagination.page"
                        :page-size="pagination.pageNum"
                        :total="count"
                        class="el-pagination"
                        background
                        layout="total, prev, pager, next"
                    ></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import refundList from '@/components/refund/refundList.vue' //订单列表
import refundApplyList from '@/components/refund/refundApplyList.vue' //订单列表

import { mapState } from 'vuex'

export default {
    name: 'refund-list',
    components: {
        refundList,
        refundApplyList,
    },
    data() {
        return {
            refund_status: -10,
            list_status_refund: [
                { status: -10, title: '申请售后' },
                // { status: 2, title: '申请记录' },
                { status: 0, title: '待处理' },
                { status: 1, title: '已完成' },
            ],
            list_order: [], //订单列表
            list_refund: [], //售后列表

            pagination: {
                page: 1,
                pageNum: 10,
            },
            count: 0,
            keyword: '',
            user_index: {},
        }
    },

    computed: {
        ...mapState(['baseInfo']),
        tabNum() {
            return (val) => {
                if (val == 0) {
                    return this.baseInfo.orderRefundNum
                } else if (val == 1) {
                    return this.baseInfo.orderRefundFinishNum
                } else {
                    return ''
                }
            }
        },
        //是否为售后申请列表 还是可申请列表
        isRefundApply() {
            return this.refund_status != -10
        },
    },

    watch: {
        refund_status() {
            this.pagination = {
                page: 1,
                pageNum: 10,
            }
            this.keyword = ''
            this.setView()
        },
    },

    created() {
        this.query_user()
        this.setView()
    },

    methods: {
        setView() {
            if (this.refund_status == -10) {
                this.query_shouhou_order() //可申请订单列表
            } else {
                this.query_apply() //售后申请列表
            }
        },

        //售后列表
        query_shouhou_order() {
            let obj = {
                ...this.pagination,
            }
            if (this.keyword != '') {
                obj.keyWord = this.keyword
            }
            this.$api('refund_afterSaleList', obj).then((res) => {
                let { code, data } = res
                if (code == 200) {
                    let { list } = data
                    this.list_order = list ? list : []
                    this.count = data.count
                    window.scrollTo({
                        top: 0,
                        left: 0,
                    })
                }
            })
        },

        //已申请售后列表
        query_apply() {
            let obj = {
                ...this.pagination,
                status: this.refund_status, //(0待处理  1已完成  -1无效)
            }
            if (this.keyword != '') {
                obj.keyWord = this.keyword
            }
            this.$api('refund_lists', obj).then((res) => {
                let { code, data } = res
                if (code == 200) {
                    let { list } = data
                    list.forEach((v) => {
                        v.is_jifen = v.products.jifen ? 1 : 0
                    })
                    this.list_refund = list ? list : []
                    this.count = data.count
                    window.scrollTo({
                        top: 0,
                        left: 0,
                    })
                }
            })
        },

        //分页
        changePage(index) {
            this.pagination = {
                page: index,
            }
            this.setView()
        },

        //搜索
        click_order_search() {
            this.setView()
        },

        //申请售后
        onApplyRefund(item) {
            this.$router.push({
                path: '/orderRefund', //refund-type
                query: {
                    id: item.id,
                },
            })
        },

        //订单详情
        refund_detail(item) {
            this.$router.push({
                // path: "/refundDetail",
                path: '/refundProgress',
                query: {
                    refund_id: item.id,
                },
            })
        },

        onClickLeft() {
            this.$router.push({
                path: '/user',
            })
        },

        //售后申请
        refund_apply(item) {
            //console.log({ ...item });
            this.$router.push(`/refund-type?order_id=${item.order_id}&inventoryId=${item.inventoryId}`)
        },

        query_user() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'users_userInfo',
                },
            }).then((res) => {
                if (res.code == 200) {
                    let data = res.data
                    this.$store.commit('set_baseInfo', data)
                }
            })
        },
    },
}
</script>

<style scoped lang="less">
.el-pagination {
    text-align: end;
}

.page {
    padding-bottom: 50px;

    .main-title {
        margin-bottom: 12px;
        padding: 0 32px;
        text-align: left;
        height: 56px;
        line-height: 56px;
        background: #ffffff;
        font-size: 16px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .page-ctx {
        margin-top: 14px;
        padding: 6px 48px 22px 48px;
        background: #fff;
    }
}

.ctx-box {
    margin-top: 30px;
}

.tab-box {
    padding-right: 20px;
    .flex-between();
    background: #ffffff;
    // border: 1px solid #cccccc;

    .tab-list {
        .flex();
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #7d7d7d;

        .tab-item {
            position: relative;
            // min-width: 96px;
            height: 48px;
            line-height: 48px;
            cursor: pointer;
            margin-right: 40px;

            .number {
                color: rgb(255, 77, 0);
            }

            &.active {
                // background: rgb(255, 77, 0);
                // color: #fff;
                font-weight: bold;
                color: rgb(255, 77, 0);
                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 3px;
                    background: rgb(255, 77, 0);
                }
            }
        }
    }

    .search-box {
        .flex();
        width: 220px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #b8c4d1;
        padding-right: 10px;
        overflow: hidden;

        input {
            background: #ffffff;
            flex: 2;
            height: 100%;
            // border: 1px solid #e2e2e2;
            border-right: none;
            outline: none;
            padding-left: 10px;
            font-size: 12px;
            color: #333333;

            &::placeholder {
                color: #cccccc;
            }
        }

        .queryBtn {
            width: 18px;
            height: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .img {
                width: 18px;
                height: 18px;
            }
        }
    }
}
@media screen and (max-width: 1024px) {
    .el-pagination {
        text-align: end;
    }

    .page {
        padding-bottom: 50px;

        .main-title {
            margin-bottom: 12px;
            padding: 0 32px;
            text-align: left;
            height: 56px;
            line-height: 56px;
            background: #ffffff;
            font-size: 16px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
        }

        .page-ctx {
            margin-top: 14px;
            padding: 26px 10px 22px 10px;
            background: #fff;
        }
    }

    .ctx-box {
        margin-top: 30px;
    }

    .tab-box {
        padding-right: 0;
        .flex-between();
        justify-content: center;
        flex-direction: column-reverse;

        .tab-list {
            .flex();
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 18px;
            margin-top: 10px;
            color: #7d7d7d;

            .tab-item {
                position: relative;
                // min-width: 96px;
                height: 48px;
                line-height: 48px;
                cursor: pointer;
                margin-right: 20px;
                font-size: 16px;

                .number {
                    color: rgb(255, 77, 0);
                }

                &.active {
                    // background: rgb(255, 77, 0);
                    // color: #fff;
                    font-weight: bold;
                    color: rgb(255, 77, 0);
                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        height: 3px;
                        background: rgb(255, 77, 0);
                    }
                }
            }
        }

        .search-box {
            .flex();
            width: 220px;
            height: 32px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #b8c4d1;
            padding-right: 10px;
            overflow: hidden;

            input {
                background: #ffffff;
                flex: 2;
                height: 100%;
                // border: 1px solid #e2e2e2;
                border-right: none;
                outline: none;
                padding-left: 10px;
                font-size: 12px;
                color: #333333;

                &::placeholder {
                    color: #cccccc;
                }
            }

            .queryBtn {
                width: 18px;
                height: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                .img {
                    width: 18px;
                    height: 18px;
                }
            }
        }
    }
}
</style>
